import classNames from 'classnames';

import BannerCenteredContent from 'components/Banner/BannerCenteredContent';

import { IBodyTextWithMarketingProperties } from './types';

import useContentStyles from './Content/styles';
import useMediaStyles from './Media/styles';
import useStyles from './styles';

function BodyTextWithMarketingPropertiesFallback({ dark }: IBodyTextWithMarketingProperties) {
  const styles = useStyles({ dark });

  const contentStyles = useContentStyles();
  const mediaStyles = useMediaStyles();
  return (
    <>
      <BannerCenteredContent className={styles.root} autoDimensions>
        <div
          className={classNames(styles.banner, {
            reversed: true,
          })}
        >
          <div className={classNames(styles.mediaWrapper, 'media')}>
            <div className={mediaStyles.rootFallback}>
              <i className="skeleton" />
            </div>
          </div>
          <div className={classNames(styles.contentWrapper, 'content')}>
            <div className={contentStyles.titleFallback}>
              <i className="skeleton" />
            </div>
            <div className={contentStyles.milestones}>
              <div className={contentStyles.rootFallback}>
                <div className={contentStyles.creativeBenefitsItemFallback}>
                  <i className="skeleton" />
                </div>
                <div className={contentStyles.creativeBenefitsItemFallback}>
                  <i className="skeleton" />
                </div>
                <div className={contentStyles.creativeBenefitsItemFallback}>
                  <i className="skeleton" />
                </div>
                <div className={contentStyles.creativeBenefitsItemFallback}>
                  <i className="skeleton" />
                </div>
              </div>
            </div>
            <div className={contentStyles.actionItemHolder}>
              <div className={contentStyles.actionFallback}>
                <i className="skeleton" />
              </div>
            </div>
          </div>
        </div>
      </BannerCenteredContent>
      <BannerCenteredContent className={styles.root} autoDimensions>
        <div className={styles.banner}>
          <div className={classNames(styles.mediaWrapper, 'media')}>
            <div className={mediaStyles.rootFallback}>
              <i className="skeleton" />
            </div>
          </div>
          <div className={classNames(styles.contentWrapper, 'content')}>
            <div className={contentStyles.titleFallback}>
              <i className="skeleton" />
            </div>
            <div className={contentStyles.milestones}>
              <div className={contentStyles.rootFallback}>
                <div className={contentStyles.creativeBenefitsItemFallback}>
                  <i className="skeleton" />
                </div>
                <div className={contentStyles.creativeBenefitsItemFallback}>
                  <i className="skeleton" />
                </div>
                <div className={contentStyles.creativeBenefitsItemFallback}>
                  <i className="skeleton" />
                </div>
                <div className={contentStyles.creativeBenefitsItemFallback}>
                  <i className="skeleton" />
                </div>
              </div>
            </div>
            <div className={contentStyles.actionItemHolder}>
              <div className={contentStyles.actionFallback}>
                <i className="skeleton" />
              </div>
            </div>
          </div>
        </div>
      </BannerCenteredContent>
    </>
  );
}

export default BodyTextWithMarketingPropertiesFallback;
